export default "__VITE_ASSET__DHwjOnS4__"